import { ProductFormulaSectionItem } from 'components/sections/ProductFormulaSection'

export const menPowerIngredients: ProductFormulaSectionItem[] = [
  {
    title: 'Maca Peruana',
    subtitle: 'Lepidium meyenii',
    description:
      'Conhecida por suas propriedades afrodisíacas em homens e mulheres, é capaz de melhorar a libido e a função sexual.',
    imgSrc: '/landings/substances/maca.webp'
  },
  {
    title: 'Vitamina E',
    subtitle: 'α-tocoferol',
    description:
      'Um antioxidante que melhora a saúde e mobilidade dos espermatozóides, além de melhorar a saúde sexual no geral.',
    imgSrc: '/landings/substances/vitamin_e.webp'
  },
  {
    title: 'Zinco',
    subtitle: 'Zn',
    description: 'Mineral importante para a saúde sexual como um todo, também atua na produção de testosterona.',
    imgSrc: '/landings/substances/zinc.webp'
  },
  {
    title: 'Magnésio',
    subtitle: 'Mg',
    description:
      'Tem papel fundamental na produção de testosterona pelo corpo, além de contribuir com a produção de espermatozóides saudáveis.',
    imgSrc: '/landings/substances/magnesium.webp'
  },
  {
    title: 'Vitamina B1',
    subtitle: 'Tiamina', // conferir
    description:
      'Necessária para o funcionamento adequado do sistema nervoso, que é importante para o desejo sexual e qualidade do orgasmo.',
    imgSrc: '/landings/substances/vitamin_b1.webp'
  },
  {
    title: 'Vitamina B2',
    subtitle: 'Riboflavina', // conferir
    description:
      'Auxilia no metabolismo energético, contribuindo para o aumento da resistência física e saúde sexual de forma geral.',
    imgSrc: '/landings/substances/vitamin_b2.webp'
  },
  {
    title: 'Vitamina B3',
    subtitle: 'Niacina',
    description:
      'Ajuda a dilatar os vasos sanguíneos, promovendo maior fluxo de sangue para a região genital e melhorando a função sexual.',
    imgSrc: '/landings/substances/vitamin_b3.webp'
  },
  {
    title: 'Vitamina B6',
    subtitle: 'Piridoxina', // conferir
    description: 'Necessária para a produção da serotonina, neurotransmissor com papel central no humor e na libido.',
    imgSrc: '/landings/substances/vitamin_b6.webp'
  }
]
